import {CheckCircleOutlined} from '@mui/icons-material';
import WarningIcon from '@mui/icons-material/Warning';
import {Chip, useTheme} from '@mui/material';
import Grid from '@mui/material/Grid';

import {BREAKPOINTS} from '../../../../const';
import useBreakpoint from '../../../../hooks/dom/useBreakpoint';
import useReportParameters from '../../../../hooks/providers/useReportParameters';

const AllSourcesStatusChip = () => {
  const {areAllSourcesConnected} = useReportParameters();
  const theme = useTheme();

  const currentBreakpoint = useBreakpoint();
  const isExtraSmallScreen = currentBreakpoint === BREAKPOINTS.xs;

  const getSourceChipStatusText = () => {
    if (!areAllSourcesConnected) return 'Connexion requise';

    return isExtraSmallScreen ? 'Connectées' : 'Toutes les sources sont connectées';
  };

  const sourcesChipStatusText = getSourceChipStatusText();
  const sourcesChipColor = areAllSourcesConnected ? '#dcfce5' : '#fef9c3';
  const sourcesChipIcon = areAllSourcesConnected ? <CheckCircleOutlined color="success.dark" sx={{fontSize: 10}} /> : <WarningIcon color="warning.dark" sx={{fontSize: 10}} />;
  const sourcesChipTextColor = areAllSourcesConnected ? 'success.dark' : `${theme.palette.warning.dark} !important`;

  return (
    <Grid item>
      <Chip
        icon={sourcesChipIcon}
        size="small"
        label={sourcesChipStatusText}
        sx={{
          fontSize: {
            xs: 11,
            sm: 14
          },
          fontWeight: 'bold',
          px: 0.5,
          backgroundColor: sourcesChipColor,
          color: sourcesChipTextColor
        }}
      />
    </Grid>
  );
};

export default AllSourcesStatusChip;
